module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_text.1790731042052.png";